<template>
  <div class="mobilemenu" id="search-page">
    <button
      class="xsearchfilters icon-menu"
      @click="
        searchPageStore.searchPageState.filterDisplay =
          !searchPageStore.searchPageState.filterDisplay
      "
    >
      Filters
    </button>
    <button
      @click="changeLayout('boxes')"
      class="icon-th button-style"
      :class="{ xselected: searchPageState.layout == 'boxes' }"
    ></button>
    <button
      @click="changeLayout('table')"
      class="icon-list button-style"
      :class="{ xselected: searchPageState.layout == 'table' }"
    ></button>
    <button
      v-if="searchPageState.advancedSearchEnabled"
      @click="searchPageState.showAdvancedSearchModal = true"
    >
      Advanced Search
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";

const searchPageStore = useSearchPageStore();

const searchPageState = computed(() => searchPageStore.searchPageState);

const emit = defineEmits<{
  (event: "changeLayout", layout: string): void;
}>();

function changeLayout(layout: string) {
  searchPageStore.searchPageState.layout = layout;
  emit("changeLayout", layout);
}
</script>

<style scoped>
* {
  font-family: "Montserrat", arial, sans-serif;
}
div.mobilemenu#search-page {
  display: none;
}

@media screen and (max-width: 992px) {
  div.mobilemenu#search-page {
    display: block;
    margin-top: 8px;
  }

  div.mobilemenu#search-page button {
    display: inline-block;
    vertical-align: middle;
    background: white;
    color: black;
    cursor: pointer;
    font-weight: bold;
    margin: 0;
    width: 98px;
    border-radius: 4px;
    height: 33px;
    line-height: 29px;
    border: 2px solid black;
    margin-right: 8px;
  }

  div.mobilemenu#search-page button.xselected {
    background: black;
    color: white;
  }
}

@media screen and (max-width: 643px) {
  div.mobilemenu#search-page {
    margin-top: 0px;
  }
}
</style>
